export const INVOICE_SETTINGS_FORM = "INVOICE_SETTINGS_FORM";
export const PAPERLESS_SETTINGS_FORM = "PAPERLESS_SETTINGS_FORM";
export const COLLECTION_DETAILS_FORM = "COLLECTION_DETAILS_FORM";
export const CONTACT_DETAILS_FORM = "CONTACT_DETAILS_FORM";
export const PRINTING_SETTING_FORM = "PRINTING_SETTING_FORM";
export const SHIPPING_DEFAULTS_FORM = "SHIPPING_DEFAULTS_FORM";
export const WORKSTATION_CONFIG_FORM = "WORKSTATION_CONFIG_FORM";
